module.exports = __webpack_public_path__ + "static/TN-0a348c5fd23f3deb3226133b753ce70a.svg";